"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useWorkplaceRequestByIdKey } from "./useWorkplaceRequestById";

/**
 * Invalidate a single workplace request's detail (its sub_status / approval_status /
 * owner …) and its activity feed, so the modal reflects a mutation immediately.
 */
export const useInvalidateWorkplaceRequest = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (requestId: string) => {
      queryClient.invalidateQueries({
        queryKey: [useWorkplaceRequestByIdKey, requestId]
      });
      queryClient.invalidateQueries({
        queryKey: ["workplaceRequestEvents", requestId]
      });
    },
    [queryClient]
  );
};
